import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import Lang from "lang.js";
import messages from "../js/messages";
import {makeRandomId} from "../mijn-portal/js/reacthelpers";
const lang = new Lang({messages, fallback: "nl"});

const FormGroup = (props) => {

    const {name, error, label, children, prepend, append, noLabel, help_text, htmlFor, onAppendMouseDown, onAppendMouseUp, prependOnClick} = props;

    return (
        <div className={`form-group input-group ${!noLabel ? 'mb-2' : 'my-0'}`}>
            {!noLabel &&
                <label className="mb-1 font-weight-bold" htmlFor={htmlFor}>{!!label ? label : lang.get('portal.'+ name)}</label>
            }
            <div className="input-group">
                {prepend && <Prepend prepend={prepend} prependOnClick={prependOnClick} name={name}/>}
                {children}
                {append && <div className="input-group-append" onMouseDown={onAppendMouseDown} onMouseUp={onAppendMouseUp}>
                    <span className="input-group-text">{append}</span>
                </div>}
                <span className="invalid-feedback" style={{display:'block'}} role="alert">
                    {error}
                </span>
            </div>
            {!!help_text && <small className="form-text"> {help_text}</small>}
        </div>
    );
}

export default FormGroup;

FormGroup.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.string,
    help_text: PropTypes.node,
    noLabel: PropTypes.bool,
    htmlFor: PropTypes.string,
}

FormGroup.defaultProps = {
    type: 'text',
    input_class: '',
};

const Prepend = ({prependOnClick, name, prepend})=>{

    const uniqueId = useMemo(()=>{
        return makeRandomId();
    }, []);

    return(
        <div
            onClick={prependOnClick && prependOnClick}
            id={`prepend_${name}_${uniqueId}`}
            className={`${prependOnClick && 'cursor-pointer'} input-group-prepend`}>
            <span className="input-group-text">{prepend}</span>
        </div>
    )
}
